export const currentFacilityActionTypes = {
  STORE_FACILITY_DETAILS: "STORE_FACILITY_DETAILS",
};
